const messages = require('./en-US/messages.json');

export default messages;
